//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../../keys_pb.js";
import { file_dxos_halo_credentials } from "../../halo/credentials_pb.js";
/**
 * Describes the file dxos/mesh/teleport/notarization.proto.
 */
export const file_dxos_mesh_teleport_notarization = /*@__PURE__*/ fileDesc("CiVkeG9zL21lc2gvdGVsZXBvcnQvbm90YXJpemF0aW9uLnByb3RvEh9keG9zLm1lc2gudGVsZXBvcnQubm90YXJpemF0aW9uIkkKD05vdGFyaXplUmVxdWVzdBI2CgtjcmVkZW50aWFscxgBIAMoCzIhLmR4b3MuaGFsby5jcmVkZW50aWFscy5DcmVkZW50aWFsMmsKE05vdGFyaXphdGlvblNlcnZpY2USVAoITm90YXJpemUSMC5keG9zLm1lc2gudGVsZXBvcnQubm90YXJpemF0aW9uLk5vdGFyaXplUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eWIGcHJvdG8z", [file_google_protobuf_empty, file_dxos_keys, file_dxos_halo_credentials]);
/**
 * Describes the message dxos.mesh.teleport.notarization.NotarizeRequest.
 * Use `create(NotarizeRequestSchema)` to create a new message.
 */
export const NotarizeRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_notarization, 0);
/**
 * *
 * Allows peers to request their credentials be written to the control feed.
 * Useful for new devices bootstraping their feeds into the space.
 *
 * @generated from service dxos.mesh.teleport.notarization.NotarizationService
 */
export const NotarizationService = /*@__PURE__*/ serviceDesc(file_dxos_mesh_teleport_notarization, 0);
//# sourceMappingURL=notarization_pb.js.map